module.exports = __webpack_public_path__ + "static/media/Cut_Diamonds.c7f64cf3.jpg";